var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDtIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6072 9.00654C1.54775 8.64039 1.86542 8.32406 2.23132 8.38505L3.78972 8.64478L6.99666 9.20938L11.1816 9.87654C11.4589 9.92076 11.6565 10.1695 11.6369 10.4496L10.7918 22.5285C10.7679 22.87 10.4373 23.1041 10.1073 23.0132L3.08633 21.0805C2.85946 21.018 2.69881 20.8163 2.68867 20.5813L2.45726 15.2168L2.15525 10.5572C2.14616 10.417 2.08296 10.2857 1.97897 10.1912L1.90852 10.1272C1.81782 10.0447 1.75775 9.93395 1.73811 9.81296L1.6072 9.00654Z",
    fill: "#01E4BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3074 10.488C13.3278 10.2204 13.5408 10.008 13.8085 9.98846L19.847 9.54815L21.8227 9.38212C22.1803 9.35207 22.4678 9.67149 22.4005 10.0239L22.1925 11.1128C22.1657 11.2534 22.0843 11.3776 21.9662 11.4585L21.9108 11.4964C21.7898 11.5792 21.7075 11.7074 21.6827 11.8519L21.2247 14.5166L20.4353 19.3384C20.4063 19.515 20.2921 19.666 20.13 19.7418L13.167 22.999C12.7913 23.1748 12.3654 22.8806 12.3969 22.467L13.3074 10.488Z",
    fill: "#50B6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06739 7.71207C4.13181 7.71207 3.73318 6.52233 4.4799 5.95866L10.9017 1.11113C11.1449 0.927523 11.46 0.86819 11.7534 0.95075L19.9551 3.25902C20.8141 3.50076 20.924 4.67368 20.125 5.07088L15.0166 7.61014C14.8817 7.67718 14.7331 7.71207 14.5825 7.71207H5.06739Z",
    fill: "#F4628F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtIconDark);
export default __webpack_public_path__ + "static/media/dt_icon_dark.3e447f5c.svg";
export { ForwardRef as ReactComponent };